import React, { useEffect } from "react"
import Header from "../components/Header"
import PromoSoonOverHandler from "../components/PromoSoonOverHandler"

const PromoOver: React.FC = () => {
	useEffect(() => {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: "smooth",
		})
	}, [])

	return (
		<>
			<div className="relative ">
				<picture>
					<source media="(min-width: 768px)" srcSet={"/images/promoSoonOverHeader.jpg"} />
					<img src={"/images/promoSoonOverHeader.jpg"} className=" block w-full" alt="Danke" />
				</picture>

				<h2 className="md:text-[70px] text-[25px]  absolute left-0 bottom-[40%] translate-y-1/2 w-full  text-center  ">
					Unser Gewinnspiel ist seit <span className="text-[#78BE20] block">dem 05.07.2026 beendet.</span>
				</h2>
			</div>
			<div className="text-center pt-12 px-4">
				<h2 className="h2 text-[#A3C35B] sm:text-[49px]">
					Vielen Dank an alle, die an unserer Aktion teilgenommen haben.
				</h2>
				<p className="font-CalibriRegular text-[14px] sm:text-[24px] mt-4 max-w-[905px] mx-auto">
					Du hast noch Fragen zur Aktion? Kein Problem! <br />
					Kontaktiere uns einfach per E-Mail unter{" "}
					<a href="mailto:bulldog@gewinnspiel-2026.de" className="underline">
						bulldog@gewinnspiel-2026.de
					</a>
					.
					<br /> Besuche uns gerne auf{" "}
					<a href="https://de.bulldogskincare.com/" target="_blank" className="underline">
						de.bulldogskincare.com
					</a>
					, um nichts zu verpassen.
				</p>

				<div className="pb-12 pt-8 text-center">
					<img src={"/images/bulldog.png"} alt="Bulldog Produkte" className="mx-auto block max-w-[220px]  " />

					<a href="https://de.bulldogskincare.com/" target="_blank" className="btn btn-green">
						Zur Bulldog-Website
					</a>
				</div>
			</div>
		</>
	)
}
export default PromoOver
